export const Sort = {
    byName: (a, b) => {
        if (a.name > b.name) return 1;
        return a.name === b.name ? 0 : -1;
    },
    byCreatedAt: (a, b) => {
        if (a.createdAt > b.createdAt) return 1;
        return a.createdAt === b.createdAt ? 0 : -1;
    },
};

export const Transform = {
    toFileElements: (data) => {
        return []
            .concat(
                data.file.map((f) => {
                    f.reactType = 'file';
                    return f;
                }),
                data.folder.map((f) => {
                    f.reactType = 'folder';
                    return f;
                })
            )
            .sort(Sort.byName);
    },
};

export const FileElement = {
    MIME_TYPE: ['application/pdf', 'image'],
    canBePreview: (fileElement) => {
        const type = FileElement.getSimplifiedType(fileElement);
        return type ? true : false;
    },
    getSimplifiedType: (fileElement) => {
        if (!fileElement) return null;
        if (fileElement._prcSimplifiedType != undefined)
            return fileElement._prcSimplifiedType;
        const fMimeType = fileElement.mimeType || '';
        for (const tp in FileElement.MIME_TYPE) {
            const t = FileElement.MIME_TYPE[tp];
            if (fMimeType.indexOf(t) >= 0) {
                if (!fileElement._isDraft) fileElement._prcSimplifiedType = t;
                return t;
            }
        }
        return (fileElement._prcSimplifiedType = null);
    },
    toLastActivity: (f) => {
        if (f.reactType === 'file') {
            return new Date(f.updatedAt).toLocaleString();
        }
        return f.lastActivity ? new Date(f.lastActivity).toLocaleString() : '-';
    },
    toHumaneReadableDate: (d) => {
        return d ? new Date(d).toLocaleString() : '-';
    },
};

export const truncateFileName = (fileName, size = 45) => {
    if (fileName.length > size) {
        return fileName.substring(0, size) + '...';
    }
    return fileName;
};

export const getOctetsValueFromString = (str) => {
    let digits = '';
    let multiplier = '';
    let stringIndex = 0;

    while (stringIndex < str.length && multiplier === '') {
        const char = str.charAt(stringIndex);
        if (char >= '0' && char <= '9') {
            digits += char;
        } else {
            multiplier = char.toLocaleLowerCase();
        }
        stringIndex++;
    }

    let result = Number(digits);
    if (multiplier === 'k') result *= 1000;
    if (multiplier === 'm') result *= 1000000;
    if (multiplier === 'g') result *= 1000000000;

    return result;
};
